import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { getUser } from "../redux/features/auth/authService";
import { selectUserDetails } from "../redux/features/auth/authSlice";
import GridLoader from "react-spinners/GridLoader";

const PrivateRoute = ({ children, allowedRoles, roleRedirects }) => {
  const { roleName, isLoggedIn, isUserDetailsLoading, hasCheckedAuth } =
    useSelector(selectUserDetails);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    if (!hasCheckedAuth) {
      dispatch(getUser());
    }
  }, [dispatch, hasCheckedAuth]);

  if (isUserDetailsLoading || !hasCheckedAuth) {
    return <div className={`loader-style`}>
      <GridLoader color="#E11F39" />
    </div>;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!allowedRoles.includes(roleName)) {
    return <Navigate to={roleRedirects[roleName] || "/login"} replace />;
  }

  return children;
};

export default PrivateRoute;
